import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import LightProfileModal from '../LightProfileModal'
import FeedContent from './components/FeedContent'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Popup from 'reactjs-popup'
import MessengerMobile from 'srcReact/MessengerPage/MessengerMobile'
import MobileModal from 'srcReact/components/common2/MobileModal'
import { useDispatch, useSelector } from 'react-redux'
import Modal from '../Modal'
import FlagReasons from 'srcReact/components/popinsContent/FlagReasons'
import DeleteMessageConfirmation from '../DeleteMessageConfirmation'
import { commonFeedActions } from './actions'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import queryString from 'query-string'
import NotFound from '../NotFound'
import CTARender from './components/CTARender'
import Spinner from '../Spinner'
import FileNavigationPopup from '../FileNavigationPopup'
import { getChildFeed, getParentFeedIdFromFeed } from 'srcReact/helpers/feedHelper'
import PinnedFeeds from './components/PinnedFeeds'

export default function FeedsTabContent({
  organizationId,
  workplaceIds,
  lastFeedRef,
  entity,
  isGroupOrganizer,
  isMember,
  isMixrOver = false,
  isOrganizer,
  handleAddCoorganizer,
  handleRemoveCoorganizer,
  handleRemoveFromGroup,
  totalUsers,
  feedIdToScroll,
  isStatic,
  openAsModal = false,
  availableCTAs = [],
  loadingFeeds = false,
  fromPageFeedContentId = 0 //fromPageFeedContentId - coming from FeedContentPage, which is a separate page for mobile, if feed is coming from notification
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isSendMessageModalOpen, setIsSendMessageModalOpen] = useState(false)
  const [userIdForMessage, setUserIdForMessage] = useState(0)
  const [feedPinnedData, setFeedPinnedData] = useState([])
  const [feedData, setFeedData] = useState([])
  const [totalFeedPinned, setTotalFeedPinned] = useState(0)
  const isFocusSetRef = useRef(null)
  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    selectedModalUser: {}
  })

  //states for files //three levels are used for three levels of image popup
  const [currentFile1, setCurrenFile1] = useState(null)
  const [currentFile2, setCurrenFile2] = useState(null)
  const [currentFile3, setCurrenFile3] = useState(null)
  const [currentFileIndex1, setCurrenFileIndex1] = useState(-1)
  const [currentFileIndex2, setCurrenFileIndex2] = useState(-1)
  const [currentFileIndex3, setCurrenFileIndex3] = useState(-1)
  const [showFilePopup1, setShowFilePopup1] = useState(false)
  const [showFilePopup2, setShowFilePopup2] = useState(false)
  const [showFilePopup3, setShowFilePopup3] = useState(false)
  const [files1, setFiles1] = useState([])
  const [files2, setFiles2] = useState([])
  const [files3, setFiles3] = useState([])
  const [feedForFilePopup1, setFeedForFilePopup1] = useState(null)
  const [feedForFilePopup2, setFeedForFilePopup2] = useState(null)
  const [feedForFilePopup3, setFeedForFilePopup3] = useState(null)
  const [feedLevelForFilePopup, setFeedLevelForFilePopup] = useState(0)

  //this variable is shifted in FeedsTabContent, because on FeedContent it was giving unexpected result
  //need to try to shift it again on FeedContent compoenent
  const replyOrCommentSentRef = useRef({ feedId: 0, send: false })
  const isModalAlreadyOpenRef = useRef(false)

  //flag post
  const [isFlagModalOpen, setIsFlagModalOpen] = useState(false)
  const [feedToFlag, setFeedToFlag] = useState(null)

  //delete message confirmation
  const [isDeleteMessagePopupOpen, setIsDeleteMessagePopupOpen] = useState(false)
  const [feedIdToDelete, setFeedIdToDelete] = useState(null)

  const {
    login: { user: loggedInUser },
    commonNewsfeed: { feeds, newsFeedType, newsFeedId, reaction, users, draftMessages },
    common: { isNative, isMobile, pageMeta },
    moderationReport: { flag_reasons },
    feedHome: { ctas }
  } = useSelector((state) => state)

  useEffect(() => {
    // const locationObj = queryString.parse(location.search)
    if (feedIdToScroll > 0 && newsFeedId > 0) {
      dispatch(commonFeedActions.locatePostInNewsFeed(feedIdToScroll, newsFeedId))
    }
  }, [newsFeedId])

  useEffect(() => {
    // to show feed content in file popup if new feed is added in file popup
    if (!feeds.loading) {
      if (feedForFilePopup1 || feedForFilePopup2 || feedForFilePopup3) {
        const parentFeed = feeds?.list?.find(
          (f) => f.id === feedForFilePopup1?.id || f.id === feedForFilePopup2?.id || f.id === feedForFilePopup3?.id
        )
        // if file modal is open for parent feed and user comments on parent feed, update feedForFilePopup1
        if (parentFeed && feedForFilePopup1 !== null && feedForFilePopup2 === null) {
          setFeedForFilePopup1(parentFeed)
        } else {
          //if file modal is open for parent and comment feed, and if user replies on comment feed, update feedForFilePopup2
          const childFeed = getChildFeed(feedForFilePopup2?.id || feedForFilePopup1?.id, feeds.list)
          if (showFilePopup2) {
            setFeedForFilePopup2(childFeed)
          }
          //if file modal is open for reply (level 3), and user replies on it, updated feed will not display as it will be visible on reply level only (level 3) and not level 4
        }
      }
    }
  }, [feeds.list, feeds.loading])

  useEffect(() => {
    //if user post comment on <FeedContentPage>(mobile- coming from notfication),
    //then we need to filter the response from post success to get only the feed in url
    //post feed api provides all the feeds, which are not needed on <FeedContentPage>
    let data = feeds.list
    if (fromPageFeedContentId > 0) {
      data = data?.filter((feed) => feed.id === fromPageFeedContentId)
    }
    const pinnedData = data?.filter((f) => f.is_pinned_to_the_top == 1)
    data = newsFeedType === 'organization' ? data : data?.filter((f) => f.is_pinned_to_the_top != 1)
    const totalPinned = pinnedData && pinnedData.length
    setFeedPinnedData(pinnedData)
    setFeedData(data)
    setTotalFeedPinned(totalPinned)
  }, [feeds.list])

  const showImageModal = (file, fileIndex, files, isFileOwner, messageId, feed, feedLevel) => {
    if (feedLevel === 1) {
      setShowFilePopup1(true)
      setFeedForFilePopup1(feed)
      setCurrenFile1(file)
      setFiles1(files)
      setCurrenFileIndex1(fileIndex)
    } else if (feedLevel === 2) {
      setShowFilePopup2(true)
      setFeedForFilePopup2(feed)
      setCurrenFile2(file)
      setFiles2(files)
      setCurrenFileIndex2(fileIndex)
    } else if (feedLevel === 3) {
      setShowFilePopup3(true)
      setFeedForFilePopup3(feed)
      setCurrenFile3(file)
      setFiles3(files)
      setCurrenFileIndex3(fileIndex)
    }
    setFeedLevelForFilePopup(feedLevel)
  }

  const closeImageModal = () => {
    if (feedLevelForFilePopup === 1) {
      setShowFilePopup1(false)
      setFeedForFilePopup1(null)
      setCurrenFile1(null)
      setFeedLevelForFilePopup(0)
      setFiles1([])
      setCurrenFileIndex1(-1)
    } else if (feedLevelForFilePopup === 2) {
      setShowFilePopup2(false)
      setFeedForFilePopup2(null)
      setCurrenFile2(null)
      setFeedLevelForFilePopup(1)
      setFiles2([])
      setCurrenFileIndex2(-1)
    } else if (feedLevelForFilePopup === 3) {
      setShowFilePopup3(false)
      setFeedForFilePopup3(null)
      setCurrenFile3(null)
      setFeedLevelForFilePopup(2)
      setFiles3([])
      setCurrenFileIndex3(-1)
    }
  }

  const setReplyOrCommentSent = (value) => {
    replyOrCommentSentRef.current = value
  }

  const showSendMessageModal = (userId) => {
    setIsSendMessageModalOpen(true)
    setUserIdForMessage(userId)
    hideUserModal()
  }

  const hideSendMessageModal = () => {
    setIsSendMessageModalOpen(false)
    setUserIdForMessage(0)
  }
  const hideUserModal = () => {
    setModalData({
      ...modalData,
      isShowUserModal: false
    })
  }

  const showUserModal = (user) => {
    setModalData({
      isShowUserModal: true,
      selectedModalUser: user
    })
  }

  const removeFromGroup = (userId) => {
    if (handleRemoveFromGroup) {
      handleRemoveFromGroup(userId)
    }
  }

  const showFlagModal = (feed) => {
    setIsFlagModalOpen(true)
    setFeedToFlag(feed)
  }
  const closeFlagModal = () => {
    setIsFlagModalOpen(false)
  }

  const showDeleteMessagePopup = (feedId) => {
    setIsDeleteMessagePopupOpen(true)
    setFeedIdToDelete(feedId)
  }
  const closeDeleteMessagePopup = () => {
    setIsDeleteMessagePopupOpen(false)
    setFeedIdToDelete(null)
  }

  const getCurrentQuantity = () => {
    return feeds.stats?.nextOffset < appConstantSettings.PAGINATION_QUANTITY
      ? appConstantSettings.PAGINATION_QUANTITY
      : feeds.stats?.nextOffset
  }

  const addReactionToMessage = (messageId, reaction) => {
    dispatch(
      commonFeedActions.addReactionToMessage(messageId, reaction, getCurrentQuantity(), organizationId, workplaceIds)
    )
  }

  const deleteReactionFromMessage = (reactionId, reactionCode, messageId) => {
    dispatch(
      commonFeedActions.deleteReactionFromMessage(
        reactionId,
        reactionCode,
        messageId,
        getCurrentQuantity(),
        organizationId,
        workplaceIds
      )
    )
  }

  const getOptionsBasedOnRole = () => {
    let options = []
    if (loggedInUser.id !== modalData.selectedModalUser.id && !isMixrOver) {
      if ((newsFeedType === 'mixr' && isOrganizer) || (newsFeedType === 'group' && isGroupOrganizer)) {
        if (modalData.selectedModalUser.role === 'co-organizer' && handleRemoveCoorganizer) {
          options.push({
            text: newsFeedType === 'mixr' ? t('mixrHome.members.removeRole') : t('groupHome.members.removeRole'),
            onClick: () => handleRemoveCoorganizer(modalData.selectedModalUser.id)
          })
        } else if (
          (modalData.selectedModalUser.role === 'member' || modalData.selectedModalUser.role === 'participant') &&
          handleAddCoorganizer
        ) {
          options.push({
            text:
              newsFeedType === 'mixr' ? t('mixrHome.members.addCoOrganizer') : t('groupHome.members.addCoOrganizer'),
            onClick: () => handleAddCoorganizer(modalData.selectedModalUser.id)
          })
        }
        if (newsFeedType === 'group' && modalData.selectedModalUser.role !== 'none' && removeFromGroup) {
          options.push({
            text: t('groupHome.members.removeMember'),
            onClick: () => removeFromGroup(modalData.selectedModalUser.id)
          })
        }
      }
    }
    return options
  }

  const renderFeedContent = (feed, feedIndex, isPinned, feedInFileModal, feedLevel = 0, isPostModalOpen) => {
    const user = users.find((u) => u.id === feed.id_user)
    const expandId = getParentFeedIdFromFeed(feedIdToScroll, feed) || feedIdToScroll
    return (
      <FeedContent
        isModal={openAsModal || isPostModalOpen || false}
        key={feedIndex}
        type={newsFeedType}
        feed={feed}
        newsFeedId={newsFeedId}
        showImageModal={showImageModal}
        handleShowDeleteMessagePopup={showDeleteMessagePopup}
        user={user}
        users={users}
        isParentFeed={true}
        quantity={getCurrentQuantity()}
        showReplyButton={true}
        deleteReactionFromMessage={deleteReactionFromMessage}
        addReactionToMessage={addReactionToMessage}
        entity={feed.relation || entity}
        isGroupOrganizer={isGroupOrganizer}
        isOrganizer={isOrganizer}
        isMember={isMember}
        showUserModal={showUserModal}
        level={feedLevel > 0 ? feedLevel : 1}
        showSendMessageModal={showSendMessageModal}
        showFlagModal={showFlagModal}
        totalUsers={totalUsers}
        feeds={isPinned ? feedPinnedData : feedData}
        feedIndex={feedIndex}
        parentIndex={feedIndex}
        feedIdToScroll={feedIdToScroll}
        feedIdToExpand={expandId}
        draftMessage={(draftMessages && draftMessages[feed.id_msg_newsfeed]) || draftMessages}
        isStatic={isStatic}
        isFlagModalOpen={isFlagModalOpen}
        isDeleteMessagePopupOpen={isDeleteMessagePopupOpen}
        replyOrCommentSent={replyOrCommentSentRef.current}
        setReplyOrCommentSent={setReplyOrCommentSent}
        {...(isPinned && fromPageFeedContentId === 0 ? { isPinned: true } : {})}
        isFocusSetRef={isFocusSetRef}
        isModalAlreadyOpenRef={isModalAlreadyOpenRef}
        feedInFileModal={feedInFileModal}
      />
    )
  }

  return (
    <React.Fragment>
      {newsFeedType !== 'organization' && feedPinnedData && feedPinnedData.length > 0 && (
        <React.Fragment>
          {/* if feed is coming from notification for mobile, don't show pinned UI */}
          {fromPageFeedContentId === 0 && (
            <PinnedFeeds
              feedPinnedData={feedPinnedData}
              totalFeedPinned={totalFeedPinned}
              entity={entity}
              renderFeedContent={renderFeedContent}
              feedContainerCSS={`${styles.feedContainer} ${isNative && styles.nativeFeedContainer}`}
              isFocusSetRef={isFocusSetRef}
              feedIdToScroll={feedIdToScroll}
              pageLastVisitedAt={pageMeta?.last_visit_date_utc}
            />
          )}
        </React.Fragment>
      )}
      {loadingFeeds && <Spinner />}
      {!loadingFeeds && feeds?.list?.length === 0 && <NotFound title={t('feed.noPost')} />}
      {feedData &&
        feedData.length > 0 &&
        feedData.map((feed, index) => {
          const isLastFeed = feedData.length - 1 === index
          return (
            <React.Fragment>
              {feed.has_been_deleted === 0 ? (
                <div
                  key={feed.id}
                  id={feed.id}
                  data-typeid={(feed.relation && feed.relation.id) || (entity && entity.id)}
                  data-type={(feed.relation && feed.relation.type) || (entity && entity.type)}
                  data-groupid={entity && entity.groupId}
                  ref={isLastFeed ? lastFeedRef : null}
                  className={`${styles.feedContainer} ${isNative && styles.nativeFeedContainer}`}>
                  {renderFeedContent(feed, index, false)}
                </div>
              ) : null}
              {availableCTAs?.length > 0 && (
                <CTARender availableCTAs={availableCTAs} currentIndex={index} ctas={ctas} displayAllCTA={false} />
              )}
            </React.Fragment>
          )
        })}
      {/* If feeds length is either 1/2/3, then show all CTAs one by one */}
      {feedData && feedData.length < appConstantSettings.FEED_COUNT_FOR_CTA && availableCTAs?.length > 0 && (
        <CTARender ctas={ctas} displayAllCTA={true} currentIndex={-1} />
      )}
      {modalData.isShowUserModal && (
        <LightProfileModal
          show={modalData.isShowUserModal}
          userIdwithRole={modalData.selectedModalUser.id}
          roleManagementOptions={getOptionsBasedOnRole()}
          closeModalWithRole={hideUserModal}
        />
      )}
      {isSendMessageModalOpen && !modalData.isShowUserModal ? (
        isMobile ? (
          <MobileModal
            isOpen={isSendMessageModalOpen}
            handleClose={hideSendMessageModal}
            closeOnDocumentClick={true}
            customContentStyle={{ height: '90%', padding: '0', border: '0' }}
            className='messengerPopup'>
            <MessengerMobile
              isMobile={true}
              isNative={isNative}
              fromFeed={true}
              userId={userIdForMessage}
              closeMessengerPopup={hideSendMessageModal}
            />
          </MobileModal>
        ) : (
          <Popup
            closeOnDocumentClick={true}
            open={isSendMessageModalOpen}
            onClose={hideSendMessageModal}
            className='messengerPopup'
            contentStyle={{ borderRadius: '4rem' }}>
            <MessengerMobile fromFeed={true} userId={userIdForMessage} closeMessengerPopup={hideSendMessageModal} />
          </Popup>
        )
      ) : null}

      {isFlagModalOpen && flag_reasons.length > 0 ? (
        isMobile ? (
          <MobileModal
            isOpen={isFlagModalOpen}
            handleClose={closeFlagModal}
            closeOnDocumentClick={true}
            headerCSS={styles.flagHeaderCSS}>
            <div className={styles.flagTitle}>
              <Icon name='flag-icon' size='large24' styleModifier={styles.flagIcon} />{' '}
              {t('moderationReport.flagPost.title')}
            </div>
            <FlagReasons feed={feedToFlag} entity={entity} closeModal={closeFlagModal} />
          </MobileModal>
        ) : (
          <Modal
            nested
            isOpen={isFlagModalOpen}
            handleClose={closeFlagModal}
            closeOnDocumentClick={true}
            headerCSS={styles.flagHeaderCSS}
            title={
              <div className={styles.flagTitle}>
                <Icon name='flag-icon' size='large24' styleModifier={styles.flagIcon} />{' '}
                {t('moderationReport.flagPost.title')}
              </div>
            }>
            <FlagReasons feed={feedToFlag} entity={entity} closeModal={closeFlagModal} />
          </Modal>
        )
      ) : null}

      {isDeleteMessagePopupOpen && (
        <Modal
          nested
          isOpen={isDeleteMessagePopupOpen}
          handleClose={closeDeleteMessagePopup}
          closeOnDocumentClick={true}>
          <DeleteMessageConfirmation
            organizationId={organizationId}
            workplaceIds={workplaceIds}
            type={newsFeedType}
            stats={feeds.stats}
            messageId={feedIdToDelete}
            closeModal={closeDeleteMessagePopup}
          />
        </Modal>
      )}
      {showFilePopup1 && currentFile1 && (
        <FileNavigationPopup
          feed={feedForFilePopup1}
          feedLevel={feedLevelForFilePopup}
          renderFeedContent={feedForFilePopup1 ? renderFeedContent : ''}
          isOpen={showFilePopup1}
          file={currentFile1}
          fileIndex={currentFileIndex1}
          files={files1}
          closeModal={closeImageModal}
          loggedInUserId={loggedInUser.id}
          idNewsFeed={newsFeedId}
        />
      )}
      {showFilePopup2 && currentFile2 && (
        <FileNavigationPopup
          feed={feedForFilePopup2}
          feedLevel={feedLevelForFilePopup}
          renderFeedContent={feedForFilePopup2 ? renderFeedContent : ''}
          isOpen={showFilePopup2}
          file={currentFile2}
          fileIndex={currentFileIndex2}
          files={files2}
          closeModal={closeImageModal}
          loggedInUserId={loggedInUser.id}
          idNewsFeed={newsFeedId}
        />
      )}
      {showFilePopup3 && currentFile3 && (
        <FileNavigationPopup
          isOpen={showFilePopup3}
          file={currentFile3}
          fileIndex={currentFileIndex3}
          files={files3}
          closeModal={closeImageModal}
          loggedInUserId={loggedInUser.id}
        />
      )}
    </React.Fragment>
  )
}
